import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const { signIn } = useAuth()
  const navigate = useNavigate()

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await signIn(email, password)
    if (error) {
      setError('Invalid email or password')
      setLoading(false)
    } else {
      navigate('/')
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--brown-dark)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px'
    }}>
      <div style={{ width: '100%', maxWidth: '360px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{
            fontFamily: 'Cormorant Garamond, serif',
            fontSize: '52px', color: 'var(--gold)',
            letterSpacing: '2px', lineHeight: 1
          }}>Jackies</div>
          <div style={{
            fontSize: '11px', color: 'var(--gold-light)',
            letterSpacing: '4px', textTransform: 'uppercase',
            marginTop: '6px', opacity: 0.7
          }}>Custom Tailor · Est. 1969</div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(184,150,62,0.2)',
            borderRadius: '16px', padding: '28px'
          }}>
            <div className="form-group">
              <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>Email</label>
              <input
                className="form-input"
                type="email" value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="your@email.com"
                required autoComplete="email"
                style={{ background: 'rgba(255,255,255,0.08)', borderColor: 'rgba(184,150,62,0.3)', color: 'white' }}
              />
            </div>
            <div className="form-group" style={{ marginBottom: '0' }}>
              <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>Password</label>
              <input
                className="form-input"
                type="password" value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required autoComplete="current-password"
                style={{ background: 'rgba(255,255,255,0.08)', borderColor: 'rgba(184,150,62,0.3)', color: 'white' }}
              />
            </div>
            {error && <p style={{ color: '#FCA5A5', fontSize: '13px', marginTop: '10px' }}>{error}</p>}
          </div>

          <button
            type="submit"
            className="btn btn-gold btn-lg"
            style={{ marginTop: '16px', borderRadius: '12px', fontSize: '16px', fontWeight: '600' }}
            disabled={loading}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.3)', fontSize: '12px', marginTop: '24px' }}>
          Jackie's Tailor Internal System
        </p>
      </div>
    </div>
  )
}
